// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"3fe8d4c6","484":"ed7b4318","690":"31c36c4b","787":"6a9ffc95"}[chunkId] + ".chunk.js";
};